module.exports = __webpack_public_path__ + "img/filter-type-oberkoerper.d2f72e0e.svg";